import dadosAgenciaComum from './dadosAgenciaComum';

export const dadosPassagensAqui = {
    ...dadosAgenciaComum,
    id: 'passagensaqui',
    nome: 'Passagens Aqui',
    instagram: 'instagram.com',
    facebook: 'facebook.com',
    youtube: 'youtube.com',
    email: 'suportevexado@gmail.com',
    idsTagManager: ['GTM-MF4MN5K']
};
